<template>
  <div>
    <v-form ref="servForm">
      <v-card flat>
        <v-card-text class="px-3">
          <v-row>
            <!-- Información General del Servicio -->
            <v-col cols="12" class="pb-2">
              <h3 class="text-subtitle-1 font-weight-bold primary--text d-flex align-center">
                <v-icon left color="primary" class="mr-2">mdi-information-outline</v-icon>
                Información General
              </h3>
            </v-col>

            <v-col cols="12" md="6" class="py-1">
              <v-text-field v-model="productoData.Nombre" :rules="rules.Nombre" label="Nombre del servicio" outlined
                dense prepend-inner-icon="mdi-format-title">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6" class="py-1">
              <v-text-field v-model="productoData.Codigo" label="Código del producto" outlined dense
                prepend-inner-icon="mdi-barcode" />
            </v-col>

            <v-col cols="12" md="6" class="py-1">
              <v-autocomplete v-model="productoData.Categoria" label="Categoría del servicio" :rules="rules.Categoria"
                :items="Categories" item-value="id" item-text="Nombre" outlined dense
                prepend-inner-icon="mdi-tag-outline">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" class="py-1">
              <v-autocomplete multiple v-model="productoData.Departamentos" label="Departamento"
                :rules="rules.Departamento" :items="modulos" outlined dense chips small-chips deletable-chips
                prepend-inner-icon="mdi-office-building">
              </v-autocomplete>
            </v-col>

            <!-- Precios y Vigencia -->
            <v-col cols="12" class="pb-2 mt-4">
              <h3 class="text-subtitle-1 font-weight-bold primary--text d-flex align-center">
                <v-icon left color="primary" class="mr-2">mdi-cash-register</v-icon>
                Precios y Vigencia
              </h3>
            </v-col>

            <v-col cols="12" md="4" class="py-1">
              <v-text-field v-model="productoData.Precio" :rules="rules.Precio"
                @keypress="$pgsHelper.onlyNumber($event, productoData.Precio, true)" label="Precio de Servicio" outlined dense
                prepend-inner-icon="mdi-currency-usd">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4" class="py-1">
              <v-select v-model="productoData.Moneda" :rules="rules.Moneda" label="Tipo de moneda" item-value="id"
                item-text="Nombre" :items="monedas" outlined dense prepend-inner-icon="mdi-cash">
              </v-select>
            </v-col>

            <v-col cols="12" md="4" class="py-1">
              <v-menu v-model="menuVigencia" :close-on-content-click="false" transition="scale-transition" offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="vaunAux" label="Fecha de vigencia (después de esta fecha no será visible)"
                    prepend-inner-icon="mdi-calendar" readonly clearable v-bind="attrs" v-on="on" outlined
                    dense></v-text-field>
                </template>
                <v-date-picker v-model="vaunAux" @input="menuVigencia = false" no-title scrollable
                  color="primary"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" class="py-1">
              <v-switch v-model="productoData.PrecioVariable" label="Precio Variable" color="primary" inset
                class="mt-0" />
            </v-col>

            <!-- Visibilidad y Canales -->
            <v-col cols="12" class="pb-2 mt-4">
              <h3 class="text-subtitle-1 font-weight-bold primary--text d-flex align-center">
                <v-icon left color="primary" class="mr-2">mdi-eye-off-outline</v-icon>
                Visibilidad
              </h3>
            </v-col>

            <v-col cols="12" md="4" class="py-2">
              <div class="switch-container pa-3 rounded-lg border-subtle">
                <v-switch v-model="productoData.opdv" label="Ocultar en el Punto de Venta" color="red darken-2"
                  hide-details inset class="mt-0 pt-0"></v-switch>
                <div class="caption grey--text mt-1 pl-12 ml-2">
                  Si se activa, no aparecerá en las pantallas de venta.
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="4" class="py-2">
              <div class="switch-container pa-3 rounded-lg border-subtle">
                <v-switch v-model="productoData.oweb" label="Ocultar en el Menú Digital" color="red darken-2"
                  hide-details inset class="mt-0 pt-0"></v-switch>
                <div class="caption grey--text mt-1 pl-12 ml-2">
                  Si se activa, no aparecerá en los menús digitales.
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="4" class="py-2">
              <div class="switch-container pa-3 rounded-lg border-subtle">
                <v-switch v-model="productoData.ocmd" label="Ocultar en el Comandero" color="red darken-2" hide-details
                  inset class="mt-0 pt-0"></v-switch>
                <div class="caption grey--text mt-1 pl-12 ml-2">
                  Si se activa, no aparecerá en los comanderos.
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-4"></v-divider>

        <v-card-actions class="justify-end px-0">
          <v-btn large text @click="$emit('toggle', false)">Cancelar</v-btn>
          <v-btn style="margin-left: 6px" color="success" large depressed @click="checkForm">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import Producto from "../../../clases/Producto.js"
import { V } from "../../../helpers/ValidationRules"
import Currency from "../../../clases/Currencies.js"
import { mapActions } from "vuex"
export default {
  name: "ServiciosForm",
  components: {
  },
  props: ["edit", "dataEdit"],
  data() {
    return {
      rules: { ...Producto.getRules(), Precio: [V.numeric('El precio debe ser un número válido')] },
      productoData: new Producto(),
      monedas: Currency.getCurrencies(),
      Categories: [],
      errors: {},
      loader: true,
      menuVigencia: false,
      vaunAux: null,
    };
  },
  methods: {
    checkForm: function (e) {
      if (this.$refs.servForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        if (this.vaunAux) {
          const dateObj = new Date(this.vaunAux + 'T00:00:00');
          this.productoData.Vaun = dateObj.getTime();
        } else {
          this.productoData.Vaun = null;
        }
        this.productoData.setAsService();
        this.$emit("successData", this.productoData, doAction);
      }
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      const cats = await this.fetchCategories();
      this.Categories = cats.map((element) => ({
        ...element,
        Nombre: element.label || element.Nombre,
      }));
    },
  },
  computed: {
    modulos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
  },
  watch: {},
  beforeMount: function () { },
  mounted() {
    this.getCategories();
    this.loader = false;
    this.$pgsHelper.log(this.dataEdit);
    if (this.edit) {
      if (this.dataEdit.Vaun) {
        const dateVal = Number(this.dataEdit.Vaun);
        if (!isNaN(dateVal)) {
          const dateObj = new Date(dateVal);
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dateObj.getDate()).padStart(2, '0');
          this.vaunAux = `${year}-${month}-${day}`;
        } else {
          this.vaunAux = this.dataEdit.Vaun;
        }
      }
      this.productoData = new Producto(this.dataEdit);
    } else {
      this.productoData = new Producto();
    }
  },
};
</script>